<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title>
                  Orders
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm6 md3 pa-5>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="fromDate"
                          label="From Date"
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fromDate"
                        no-title
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md3 pa-5>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="toDate"
                          label="To Date"
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="toDate"
                        no-title
                        @input="menu2 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- <v-flex xs12 sm6 md3 pa-5>
                    <v-select
                      v-model="filter"
                      :items="filterStatus"
                      item-text="name"
                      item-value="value"
                      item-color="#8d8d8d"
                      color="#8d8d8d"
                      outlined
                      dense
                      label="Status"
                    >
                    </v-select>
                  </v-flex> -->
                </v-card-title>
              </v-card>
              <v-card class="mb-4">
                <v-card-text>
                  <v-layout wrap style="align-items: center" justify-center>
                    <!-- <v-flex xs12 sm6 md2 pt-2 align-self-start>
                      <v-select
                        v-model="status"
                        :items="statusList"
                        item-text="text"
                        item-value="value"
                        label="Delivery Status"
                        size
                        dense
                        outlined
                      >
                      </v-select>
                    </v-flex> -->
                    <v-flex xs12 sm6 md6 lg6> </v-flex>
                    <v-flex xs12 sm6 md6 lg6>
                      <v-layout wrap justify-center>
                        <v-flex xs6 sm6 md4 text-right pt-2
                          >Items Per Page</v-flex
                        >
                        <v-flex xs6 sm6 md2>
                          <v-select
                            solo
                            flat
                            v-model="itemsPerPage"
                            :items="ItemsCount"
                            dense
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs6
                          sm6
                          md2
                          text-center
                          pt-2
                          style="color: black"
                        >
                          {{ pageStart }}-{{ pageEnd }} of {{ count }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-right>
                          <span v-if="page > 1">
                            <v-icon @click="prevpage" color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-center>
                          <!-- <v-text-field
                              v-model="page"
                              color="#26af82"
                              min="1"
                              :dense="true"
                              :max="totalpages"
                              type="number"
                              class="centered-input"
                            ></v-text-field> -->
                          {{ page }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-left>
                          <span v-if="page < totalpages">
                            <v-icon @click="nextpage" color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-data-table
                  bordered
                  :headers="headers"
                  :items="customers"
                  hide-default-footer
                  :items-per-page="itemsPerPage"
                  class="row-pointer tablewid pb-12"
                  @click:row="rowClicked"
                >
                  <!-- @click:row="rowClicked" -->
                  <template v-slot:item.fullname="{ item }">
                    <span v-if="item.uid">
                      {{ item.uid.customerid.firstName }}
                      {{ item.uid.customerid.lastName }}
                    </span>
                  </template>
                  <template v-slot:item.products="{ item }">
                    <span v-for="(items, i) in item.products" :key="i">
                      {{ items.name }} </span
                    ><br />
                  </template>
                  <template v-slot:item.Orderdate="{ item }">
                    <span v-if="item.create_date">
                      {{ formatDate(item.create_date) }}
                    </span>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      headers: [
        { text: "Ord ID", value: "orderID" },
        { text: "Customer", value: "fullname" },
        { text: "Products", value: "products" },
        { text: "Amount", value: "totalAmount" },
        { text: "Order Date", value: "Orderdate" },
        // { text: "Actions", value: "actions", sortable: false },
      ],
      filter: null,
      filterStatus: [
        { name: "All", value: null },
        { name: "Pending", value: "Pending" },
        { name: "Approved", value: "Approved" },
        { name: "Rejected", value: "Rejected" },
      ],
      showsnackbar: false,
      msg: null,
      timeout: 5000,
      deleteCustomer: false,
      mini: true,
      customers: [],
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 25,
      page: 1,
      fromDate: new Date(),
      toDate: new Date(),
      menu1: false,
      menu2: false,
      totalpages: 0,
      ItemsCount: [25, 50, 100],
      statusList: [
        { value: "ordered", text: "Ordered" },
        { value: "packed", text: "Packed" },
        { value: "shipped", text: "Shipped" },
        { value: "outfordelivery", text: "Out for Delivery" },
        { value: "delivered", text: "Delivered" },
        // { value: "Return", text: "Return" },
      ],
      status: null,
    };
  },
  beforeMount() {
    this.getPurchases();
    if (this.fromDate) {
      this.fromDate.setDate(this.fromDate.getDate());
      this.fromDate = this.fromDate.toISOString().substr(0, 10);
    }
    if (this.toDate) {
      this.toDate.setDate(this.toDate.getDate());
      this.toDate = this.toDate.toISOString().substr(0, 10);
    }
  },
  watch: {
    itemsPerPage: function () {
      //   this.getPurchases();
    },
    status: function () {
      this.getPurchases();
    },
    fromDate() {
      this.getPurchases();
    },
    toDate() {
      this.getPurchases();
    },
  },
  methods: {
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getPurchases();
        // } else {
        //   this.page--;
        //   this.getPurchases();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getPurchases();
        // } else {
        //   this.page++;
        //   this.getPurchases();
        // }
      }
    },
    getPurchases() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/orders/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          // paymentstatus:"initiate",
          limit: this.itemsPerPage,
          page: this.page,
          // status: this.status,
          from: this.fromDate,
          to: this.toDate,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.customers = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );

          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },

    rowClicked(item) {
      this.$router.push("/Purchase/" + item._id);
    },
  },
};
</script>
<style >
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>



